import {onValue} from 'firebase/database';
import {createRealtimeDBRef} from 'network/firebase';
import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {DrugItem} from 'store/types';

const useDrugList = () => {
  const {state} = useLocation();
  const {pharmacy, drugCategory} = state;
  const navigate = useNavigate();
  const [drugList, setDrugList] = useState<DrugItem[]>([]);

  const navigateToDrugDetails = (drug: DrugItem) => {
    console.log(`trying to navigate to /drug-details/${drug.uid}`);
    navigate('/drug-details', {state: {drug}});
  };

  useEffect(() => {
    const drugListRef = createRealtimeDBRef(`${pharmacy}/${drugCategory}`);

    onValue(drugListRef, (snapshot) => {
      const drugItemList: DrugItem[] = Object.values(snapshot.val() || {});
      setDrugList(drugItemList);
    });
  }, [drugCategory, pharmacy]);

  return {
    drugList,
    navigateToDrugDetails,
  };
};

export default useDrugList;
